import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { keyframes } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B50, N30, N40, N50, N60 } from '@atlaskit/theme/colors';
const placeholderShimmer = keyframes({
  '0%': {
    backgroundPosition: '-20px 0'
  },
  '100%': {
    backgroundPosition: '60px 0'
  }
});
const appearanceValues = {
  darkGray: {
    background: `var(--ds-background-accent-gray-subtler, ${N50})`,
    animation: `var(--ds-background-accent-gray-subtle, ${N60})`
  },
  gray: {
    background: `var(--ds-background-accent-gray-subtlest, ${N30})`,
    animation: `var(--ds-skeleton, ${N40})`
  },
  blue: {
    background: `var(--ds-background-accent-blue-subtlest, ${B50})`,
    animation: "var(--ds-background-information-hovered, #cce0ff)"
  }
};

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ShimmerSkeleton = styled.div`
	height: ${({
  height
}) => height || 'auto'};
	width: ${({
  width
}) => width || 'auto'};
	border-radius: ${({
  borderRadius
}) => borderRadius || 0};
	user-select: none;
	background: ${({
  appearance = 'gray'
}) => appearanceValues[appearance].background};

	background-image: ${({
  appearance = 'gray'
}) => `linear-gradient(
    to right,
    transparent 0%,
   ${appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`};
	background-repeat: no-repeat;
	background-size: ${({
  height,
  isShimmering
}) => isShimmering ? `40px ${height};` : '0px'};

	animation: ${placeholderShimmer} 1s linear infinite forwards;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ShimmerSkeletonSpan = styled.span`
	height: ${({
  height
}) => height || 'auto'};
	width: ${({
  width
}) => width || 'auto'};
	border-radius: ${({
  borderRadius
}) => borderRadius || 0};
	user-select: none;
	background: ${({
  appearance = 'gray'
}) => appearanceValues[appearance].background};

	background-image: ${({
  appearance = 'gray'
}) => `linear-gradient(
    to right,
    transparent 0%,
   ${appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`};
	background-repeat: no-repeat;
	background-size: ${({
  height,
  isShimmering
}) => isShimmering ? `40px ${height};` : '0px'};

	animation: ${placeholderShimmer} 1s linear infinite forwards;
`;
export const SpanSkeleton = ({
  width,
  appearance = 'gray',
  height = 14,
  borderRadius = 0,
  isShimmering = true,
  testId,
  style = {}
}) => /*#__PURE__*/React.createElement(ShimmerSkeletonSpan, {
  width: typeof width === 'number' ? `${width}px` : width,
  height: typeof height === 'number' ? `${height}px` : height,
  borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
  appearance: appearance,
  isShimmering: isShimmering,
  "data-testid": testId
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
  ,
  style: style
});
export const Skeleton = ({
  width,
  appearance = 'gray',
  height = 14,
  borderRadius = 0,
  isShimmering = true,
  testId,
  style = {}
}) => /*#__PURE__*/React.createElement(ShimmerSkeleton, {
  width: typeof width === 'number' ? `${width}px` : width,
  height: typeof height === 'number' ? `${height}px` : height,
  borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
  appearance: appearance,
  isShimmering: isShimmering,
  "data-testid": testId
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
  ,
  style: style
});
export default Skeleton;